import { render, staticRenderFns } from "./priceCombinationResult.vue?vue&type=template&id=646f3ecc&scoped=true&"
import script from "./priceCombinationResult.vue?vue&type=script&lang=js&"
export * from "./priceCombinationResult.vue?vue&type=script&lang=js&"
import style0 from "./priceCombinationResult.vue?vue&type=style&index=0&id=646f3ecc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646f3ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('646f3ecc')) {
      api.createRecord('646f3ecc', component.options)
    } else {
      api.reload('646f3ecc', component.options)
    }
    module.hot.accept("./priceCombinationResult.vue?vue&type=template&id=646f3ecc&scoped=true&", function () {
      api.rerender('646f3ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Price/priceCombinationResult.vue"
export default component.exports